import { api } from "@/lib/api";

export interface CreditsBalance {
  balance: number;
  lifetime_granted: number;
  lifetime_spent: number;
  lifetime_refunded: number;
}

export const getCreditsBalance = () => api.get<CreditsBalance>("/credits/balance").then((r) => r.data);
export const formatCredits = (n: number, locale?: string) => n.toLocaleString(locale);

// Uniform handling of paid-operation errors (backend is the source of truth).
export const creditsErrorCode = (err: any): "INSUFFICIENT_CREDITS" | "COST_CHANGED" | null => {
  const d = err?.response?.data?.detail;
  return d && typeof d === "object" && (d.code === "INSUFFICIENT_CREDITS" || d.code === "COST_CHANGED") ? d.code : null;
};
export const costChangedCredits = (err: any): { old: number; next: number } | null => {
  const d = err?.response?.data?.detail;
  return d?.code === "COST_CHANGED" ? { old: d.old_credits, next: d.new_credits } : null;
};
